import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=bb5ad810&scoped=true"
import script from "./loading-spinner.vue?vue&type=script&lang=js"
export * from "./loading-spinner.vue?vue&type=script&lang=js"
import style0 from "./loading-spinner.vue?vue&type=style&index=0&id=bb5ad810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5ad810",
  null
  
)

export default component.exports